module.exports = __webpack_public_path__ + "static/img/map1.a3ff1dbb.png";